import React from 'react';
import { cn } from '@/utils/cn';
import Button from '@/app/components/Button';
import Icon from '@/app/components/Icon';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsOpenGlobalSearchModal,
  setIsSearchActive,
} from '@/redux/reducers/search-reducer';

function SearchInput({ onSearchActive = () => {} }) {
  const dispatch = useDispatch();
  const { isSearchActive } = useSelector((state) => state.search);

  return (
    <div
      className={cn(
        'hidden lg:flex w-full lg:w-full lg:max-w-[261px] h-[40px] lg:h-[32px] items-center justify-center bg-white px-8 py-0 lg:px-4 lg:py-4 border border-atelier rounded-[28px] gap-[8px] lg:gap-4',
        {
          '!flex': isSearchActive,
        },
      )}
      role="presentation"
      onClick={() => {
        dispatch(setIsOpenGlobalSearchModal(true));
        dispatch(setIsSearchActive(true));
        onSearchActive(true);
      }}
    >
      <input
        className="w-full order-2 lg:order-1 border-none bg-transparent pl-0 lg:pl-16 py-1 placeholder:text-lightslategray placeholder:text-16 placeholder:font-normal lg:placeholder:font-medium placeholder:!font-encode-sans text-riverbed placeholder:leading-20 placeholder:tracking-[0.32px] outline-none focus:outline-none "
        type="text"
        name="search"
        readOnly
        placeholder="Search Here"
      />
      <Button type="link" className="order-1 lg:order-2 mr-0 lg:mr-10 !p-0">
        <Icon
          type="search"
          className="size-[24px]"
          color={isSearchActive ? '#49525E' : '#DB0032'}
        />
      </Button>
    </div>
  );
}

export default SearchInput;
